import GameActions from './game-actions';

export default GameActions;
